<template>
    <div >
        <div class="columns pt-0 pb-0 mt-0 mb-0 is-vcentered">
            <div class="column is-narrow pt-1 pb-1">
                <i class="fa fa-filter fa-lg"></i>
            </div>
            <div class="column pt-0 pb-0">
                <div class="columns is-multiline  mt-0 mb-0 is-vcentered is-variable is-1 is-mobile">
                    <div class="column is-narrow pt-1 pb-1" v-if="filterVisibility.search">
                        <input
                            type="text"
                            v-model="_search"
                            class="input is-medium "
                            placeholder="Suchen"
                        >
                    </div>
                    <div class="column is-narrow pt-1 pb-1" v-if="filterVisibility.tripName">
                        <input
                            type="text"
                            v-model="filters.tripName"
                            class="input is-medium  is-hidden-on-small"
                            placeholder="Reisetitel oder ResaNr suchen"
                        >
                    </div>
                    <div class="column is-narrow pt-1 pb-1" v-if="filterVisibility.destinations">
                        <async-select
                            api="destinations"
                            v-model="filters.destinations"
                            class="is-smaller  is-shorter"
                            placeholder="Destinationen"
                            multiple
                            init-search
                            compact
                            :compact-label="['Destination', 'Destinationen']"
                        />
                    </div>
                    <div class="column is-narrow pt-1 pb-1" v-if="filterVisibility.country">
                        <multiselect
                            track-by="label"
                            label="name"
                            class="is-smaller  is-hidden-on-small is-shorter"

                            v-bind:options="resources.countries"
                            v-model="filterCountry"
                            placeholder="Land"
                        >
                            <div
                                slot="clear"
                                class="multiselect__clear"
                                v-if="!!filterCountry"
                                v-on:click.prevent.stop="filterCountry = ''"
                            ></div>
                        </multiselect>
                    </div>
                    <template v-if="filterVisibility.orderStatus">
                        <div class="column is-narrow pt-1 pb-1 pr-0">
                            <color-switch @input="setOrderStatus"></color-switch>
                        </div>
                        <div class="column is-narrow pt-1 pb-1 pl-0">
                            <multiselect
                                compact
                                :compact-label="['Status', 'Stati']"
                                v-model="orderStatus"
                                v-bind:options="options.orderStatus ? options.orderStatus : []"
                                track-by="key"
                                label="value"
                                multiple
                                class="is-smaller  is-shorter"
                                placeholder="Status filtern"
                            >
                            </multiselect>
                        </div>
                    </template>
                    <div class="column is-narrow pt-1 pb-1" v-if="filterVisibility.dateRange">
                        <div class="flatpickr-combined ">
                            <input-date v-model="filters.startAt" />
                            <span>-</span>
                            <input-date v-model="filters.endAt" />
                        </div>
                    </div>
                    <div class="column is-narrow pt-1 pb-1" v-if="filterVisibility.organisation && resources.organisations.length > 1">
                        <multiselect
                            v-bind:options="resources.organisations"
                            v-model="filterOrganisation"
                            class="is-smaller is-shorter "
                            track-by="id"
                            label="name"
                            placeholder="Organisation"
                        >
                            <div
                                slot="clear"
                                class="multiselect__clear"
                                v-if="!!filterOrganisation"
                                v-on:click.prevent.stop="filterOrganisation = ''"
                            ></div>
                        </multiselect>
                    </div>
                    <div class="column is-narrow pt-1 pb-1" v-if="filterVisibility.requestSource">
                        <multiselect
                            compact
                            :compact-label="['Anfragequelle', 'Anfragequellen']"
                            v-model="requestSource"
                            :options="options && options.requestSourceList ? options.requestSourceList : []"
                            track-by="key"
                            label="value"
                            multiple
                            class="is-smaller is-shorter"
                            placeholder="Anfragequelle"
                        >
                        </multiselect>
                    </div>
                    <div class="column is-narrow pt-1 pb-1" v-if="filterVisibility.mainLanguage">
                        <multiselect
                            compact
                            :compact-label="['Sprache', 'Sprachen']"
                            v-model="clientMainLanguage"
                            :options="options && options.mainLanguage ? options.mainLanguage : []"
                            track-by="key"
                            label="value"
                            multiple
                            class="is-smaller is-shorter"
                            placeholder="Kundensprache"
                        >
                        </multiselect>
                    </div>
                    <div class="column is-narrow pt-1 pb-1" v-if="filterVisibility.tags">
                        <multiselect
                            compact
                            :options="options && options.orderTags ? options.orderTags : []"
                            class="is-small is-shorter "

                            v-model="filterTags"
                            v-bind:taggable="true"
                            multiple
                            placeholder="Tags"
                            v-on:tag="addTag"
                        >
                            <span slot="caret" ></span>
                        </multiselect>
                    </div>
                    <div class="column is-narrow pt-1 pb-1">
                        <button
                            class="button filter-settings-btn"
                            title="Filter konfigurieren"
                            v-on:click.prevent="showSettingsModal = true"
                        >
                            <i class="material-icons">settings</i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <modal :visible="showSettingsModal" @closeModal="showSettingsModal = false" classes="filter-settings-modal">
            <template slot="header">Filter konfigurieren</template>
            <template slot="content">
                <p class="mb-3">Filter ein- oder ausblenden:</p>
                <div class="filter-settings-list">
                    <label v-for="(label, key) in filterLabels" :key="key" class="filter-settings-item">
                        <input type="checkbox" v-model="filterVisibility[key]" />
                        <span>{{ label }}</span>
                    </label>
                </div>
            </template>
            <template slot="footer">
                <button class="button is-primary" @click.prevent="showSettingsModal = false">Schließen</button>
            </template>
        </modal>
    </div>
</template>

<script>
import value, { options } from './_mixins';
import debounce from 'lodash/debounce';
import { AsyncSelect, Multiselect, InputDate } from '@components/form'
import ColorSwitch from "@components/form/ColorSwitch";
import Modal from '@components/Modal';
import isEqual from "lodash/isEqual";

const STORAGE_KEY = 'user-dashboard/filter-visibility';

const defaultVisibility = () => ({
    search: true,
    tripName: true,
    destinations: true,
    country: true,
    orderStatus: true,
    dateRange: true,
    organisation: true,
    requestSource: true,
    mainLanguage: true,
    tags: true,
});

function loadVisibility() {
    try {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            return { ...defaultVisibility(), ...JSON.parse(stored) };
        }
    } catch (e) {}
    return defaultVisibility();
}

export default {
    mixins: [ value, options ],

    components: {
        ColorSwitch,
        AsyncSelect,
        Multiselect,
        InputDate,
        Modal,
    },

    data: function () {
        return {
            showSettingsModal: false,
            filterVisibility: loadVisibility(),
            filterLabels: {
                search: 'Suchen',
                tripName: 'Reisetitel / ResaNr',
                destinations: 'Destinationen',
                country: 'Land',
                orderStatus: 'Status',
                dateRange: 'Zeitraum',
                organisation: 'Organisation',
                requestSource: 'Anfragequelle',
                mainLanguage: 'Sprache des Kunden',
                tags: 'Tags',
            },
        };
    },

    watch: {
        filterVisibility: {
            deep: true,
            handler: function (value) {
                try {
                    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
                } catch (e) {}
            }
        },
        'filterVisibility.search': function (visible) {
            if (!visible) this.$emit('input', { ...this.value, _search: '' });
        },
        'filterVisibility.tripName': function (visible) {
            if (!visible) this.$emit('input', { ...this.value, tripName: '' });
        },
        'filterVisibility.destinations': function (visible) {
            if (!visible) this.$emit('input', { ...this.value, destinations: [] });
        },
        'filterVisibility.country': function (visible) {
            if (!visible) this.$emit('input', { ...this.value, country: null });
        },
        'filterVisibility.orderStatus': function (visible) {
            if (!visible) this.$emit('input', { ...this.value, orderStatus: [] });
        },
        'filterVisibility.dateRange': function (visible) {
            if (!visible) this.$emit('input', { ...this.value, startAt: null, endAt: null });
        },
        'filterVisibility.organisation': function (visible) {
            if (!visible) this.$emit('input', { ...this.value, organisation: null });
        },
        'filterVisibility.requestSource': function (visible) {
            if (!visible) this.$emit('input', { ...this.value, requestSource: [] });
        },
        'filterVisibility.mainLanguage': function (visible) {
            if (!visible) this.$emit('input', { ...this.value, mainLanguage: [] });
        },
        'filterVisibility.tags': function (visible) {
            if (!visible) this.$emit('input', { ...this.value, traitTags: [] });
        },
    },

    computed: {
         _search: {
            get: function () { return this.filters._search },
            set: debounce(function (value) {
                this.$emit('input', {...this.value, _search: value})
            }, 600)
        }
    },

    methods: {
        setOrderStatus: function (value) {

            let inActives = ['deleted', 'offer_declined', 'booking_cancelled']
            let oldStatuses = this.options.orderStatus.filter(item => this.filters.orderStatus.includes(item.key));
            let newStatuses = this.options.orderStatus.filter(item => value === 'is-green' ? !inActives.includes(item.key) : inActives.includes(item.key));



            this.orderStatus = isEqual(oldStatuses, newStatuses) ? [] : newStatuses;
        },
        addTag (tag) {
            let tags = this.filterTags || [];
            tags.push(tag);
            this.filterTags   = tags;
        },
    }
}
</script>
